export default "__VITE_ASSET__CY91zQXe__"